import '../../../../../../Avency.Sprehe.Base/Resources/Private/Assets/JavaScript/Project/globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const isotopeGridSelector = '.isotope__grid',
            isotopeItemSelector = '.isotope__grid-item',
            isotopeFilterSelector = '.isotope__filter';

        if (document.querySelector(isotopeGridSelector)) {
            // Init Isotope
            const grid = new window.Isotope(isotopeGridSelector, {
                itemSelector: isotopeItemSelector
            });
            grid.arrange();

            // store filter for each group
            let filters = {};

            const isotopeFilters = document.querySelectorAll(isotopeFilterSelector);
            Array.from(isotopeFilters).forEach(function (isotopeFilter) {
                isotopeFilter.addEventListener('change', function () {
                    const selectedValue = isotopeFilter.value;
                    const option = isotopeFilter.querySelector('[value="' + selectedValue + '"]');

                    if (option) {
                        const filterGroup = option.dataset.filter;
                        filters[filterGroup] = '.' + option.value;
                    }

                    // Remove unselected elements from filter
                    const notSelectedValues = isotopeFilter.querySelectorAll('option:not(:checked)');
                    Array.from(notSelectedValues).forEach(function(element) {
                        const filterGroup = element.dataset.filter;

                        if (filterGroup) {
                            delete filters[filterGroup];
                        }
                    });

                    grid.arrange({
                        filter: concatValues(filters)
                    });
                }, {passive: true});
            });
        }

        /**
         * flatten object by contacting values
         *
         * @param obj
         * @return {string}
         */
        function concatValues(obj) {
            let value = '';

            for (let prop in obj) {
                value += obj[prop];
            }
            return value;
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
